import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowDown, BsArrowRight } from "react-icons/bs";
import "./Home.css";
import aztecRobot from "../../assets/images/aztec-robot.png";
import ActionButton from "../../components/ActionButton/ActionButton";

function Home() {
  const navigate = useNavigate();
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
  const [currentPlaceholder, setCurrentPlaceholder] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  const placeholders = useMemo(() => [
    "Dame un consejo para hoy",
    "Explícame este código",
    "Crea un poema de México",
    "¿Cuál es la capital de Mauritania?",
    "Ayudame a redactar un correo",
    "Recomiéndame 10 libros",
  ], []);

  useEffect(() => {
    let timeout;
    const currentText = placeholders[placeholderIndex];
    const timeoutDuration = isDeleting ? 30 : 50;

    if (!isDeleting && currentPlaceholder === currentText) {
      timeout = setTimeout(() => {
        setIsDeleting(true);
      }, 1000);
    } else if (isDeleting && currentPlaceholder === "") {
      setIsDeleting(false);
      setPlaceholderIndex((prev) => (prev + 1) % placeholders.length);
    } else {
      timeout = setTimeout(() => {
        setCurrentPlaceholder((prev) => {
          if (isDeleting) {
            return prev.slice(0, -1);
          }
          return currentText.slice(0, prev.length + 1);
        });
      }, timeoutDuration);
    }

    return () => clearTimeout(timeout);
  }, [placeholderIndex, currentPlaceholder, isDeleting, placeholders]);

  const handleSubmit = () => {
    const inputElement = document.querySelector(".search-input");
    const inputText = inputElement.value.trim();

    if (inputText) {
      navigate("/chat", { state: { initialMessage: inputText } });
    } else {
      navigate("/chat");
    }
  };

  return (
    <div className="home-container">
      <section className="search-section">
        <div className="search-container">
          <input
            type="text"
            placeholder={currentPlaceholder}
            className="search-input"
            onMouseEnter={(e) => e.target.style.borderColor = "#444"}
            onMouseLeave={(e) => e.target.style.borderColor = "#333"}
            onKeyPress={(e) => {
              if (e.key === "Enter") handleSubmit();
            }}
          />
          <button
            className="search-button"
            onClick={handleSubmit}
            onMouseEnter={(e) =>
              e.target.style.backgroundColor = "var(--azteq-green-dark)"}
            onMouseLeave={(e) =>
              e.target.style.backgroundColor = "var(--azteq-green)"}
          >
            <BsArrowRight color="black" size={24} />
          </button>
        </div>
        <div className="scroll-indicator">
          <BsArrowDown size={24} />
        </div>
      </section>

      <div className="divider" />

      <section className="content-section">
        <h1 className="content-header">AI Verticalizada</h1>
        <p>
          Inteligencia Artificial enfocada localmente, utilizando los últimos
          modelos.
        </p>
        <div className="content-button-container">
          <ActionButton text="conoce más" to="/about" />
        </div>
      </section>

      <div className="divider" />

      <section className="image-section">
        <div className="image-content">
          <img
            src={aztecRobot}
            alt="Aztec Robot"
            className="aztec-image"
          />
          <div className="button-container">
            <ActionButton text="chat" to="/chat" />
          </div>
        </div>
      </section>

      <div className="divider" />

      <div
        className="background-image"
        style={{
          backgroundImage: `url(${aztecRobot})`,
        }}
      />
    </div>
  );
}

export default Home;
